module.exports = __webpack_public_path__ + "static/media/logo-1-white.3f171e93.svg";